import { useMutation } from "@tanstack/react-query";
import { getOperationalNotificationsQueryKey } from "./use-get-operational-notifications";
import { toast } from "~served/ui-comps/toast";
import { gqlReq } from "~/libs/gql";
import {
	GetOperationalNotificationsQuery,
	ResolveAssistanceDocument,
	ResolveAssistanceMutationVariables,
} from "~/types/__generated/gql/graphql";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		mutation ResolveAssistance($id: ObjectID!) {
			resolveAssistance(id: $id) {
				_id
			}
		}
	`
);

export const resolveAssistanceMutationFn = async (
	variables: ResolveAssistanceMutationVariables,
) => {
	const data = await gqlReq({
		document: ResolveAssistanceDocument,
		variables,
	});
	queryClient.setQueryData<GqlResultOf<GetOperationalNotificationsQuery>>(
		getOperationalNotificationsQueryKey(),
		(prev) => (prev ? prev.filter(({ _id }) => _id !== data._id) : []),
	);
	toast.dismiss(data._id);

	return data;
};

export const useResolveAssistance = () =>
	useMutation({ mutationFn: resolveAssistanceMutationFn });
